export const BOARDS_ITEM_TYPE = 'boards' as const;
export const FILTERS_ITEM_TYPE = 'filters' as const;
export const DASHBOARDS_ITEM_TYPE = 'dashboards' as const;
export const ISSUES_ITEM_TYPE = 'issues' as const;
export const PLANS_ITEM_TYPE = 'plans' as const;
export const PROJECTS_ITEM_TYPE = 'projects' as const;
export const QUEUES_ITEM_TYPE = 'queues' as const;

export const VALID_ITEM_TYPES = [
	BOARDS_ITEM_TYPE,
	DASHBOARDS_ITEM_TYPE,
	FILTERS_ITEM_TYPE,
	ISSUES_ITEM_TYPE,
	PLANS_ITEM_TYPE,
	PROJECTS_ITEM_TYPE,
	QUEUES_ITEM_TYPE,
] as const;

export const VALID_ITEM_TYPENAMES = [
	'JiraProject',
	'JiraCustomFilter',
	'JiraSystemFilter',
	'JiraDashboard',
	'JiraPlan',
	'JiraBoard',
	'JiraServiceManagementQueue',
] as const;
